import { Controller } from "@hotwired/stimulus"

const PLAYER_API = "https://player.vimeo.com/api/player.js"

// Connects to data-controller="public-video"
// Reports a visit when the page opens, and a play the first time the video starts.
export default class extends Controller {
  static targets = ["player"]
  static values = { url: String }

  connect() {
    // Turbo briefly shows a cached copy before the real page; only count the real one.
    if (document.documentElement.hasAttribute("data-turbo-preview")) return

    this.record("visit")

    this.loadPlayerApi()
      .then(() => {
        this.player = new Vimeo.Player(this.playerTarget)
        this.player.on("play", () => {
          // Vimeo fires play again after every pause, but it is still one view.
          if (this.played) return
          this.played = true
          this.record("play")
        })
      })
      .catch(() => console.warn("Vimeo player API unavailable; plays will not be counted"))
  }

  disconnect() {
    if (this.player) this.player.off("play")
  }

  loadPlayerApi() {
    if (window.Vimeo) return Promise.resolve()

    return new Promise((resolve, reject) => {
      const script = document.createElement("script")
      script.src = PLAYER_API
      script.onload = resolve
      script.onerror = reject
      document.head.appendChild(script)
    })
  }

  record(category) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')

    fetch(this.urlValue, {
      method: "POST",
      keepalive: true,
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken ? csrfToken.getAttribute("content") : ""
      },
      body: JSON.stringify({ category: category })
    }).catch(error => console.warn("Logging failed", error))
  }
}
